import { ReactNode } from 'react'

import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { SimpleDivider } from '@tribeplatform/react-ui-kit/Divider'

import { T } from '../../i18n/components/T.js'

interface Props {
  children: ReactNode
}
export const ModelSettingSections = ({ children }: Props) => {
  return <div className="space-y-2">{children}</div>
}

interface HocProps {
  children: ReactNode
  showDivider?: boolean
}
const SectionHOC = (title: JSX.Element, defaultOpen?: boolean) => {
  return ({ children, showDivider = true }: HocProps) => {
    return (
      <>
        {showDivider && <SimpleDivider variant="subdued" />}
        <Accordion
          defaultOpen={defaultOpen}
          iconAlign="trailing"
          className="-mx-2"
        >
          <Accordion.Button noHover className="hover:text-content-hovered">
            {title}
          </Accordion.Button>
          <Accordion.Panel>
            <div className="space-y-5">{children}</div>
          </Accordion.Panel>
        </Accordion>
      </>
    )
  }
}

ModelSettingSections.General = SectionHOC(
  <T defaultMessage="General" id="Generics.General" />,
  true,
)
ModelSettingSections.Interactions = SectionHOC(
  <T defaultMessage="Interactions" id="Generics.Interactions" />,
  true,
)
ModelSettingSections.Fields = SectionHOC(
  <T defaultMessage="Fields" id="Generics.Fields" />,
  true,
)
